import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from "react";
import { StyleProvider, createTheme } from "@animech/ui";
import { HashRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GlobalStyle } from "./global.style";
import { theme as piabTheme } from "theme";
import { ConfigIdProvider } from "providers/config-id";
import Routes from "ui/routes";
import { AuthProvider } from "authentication";
var theme = createTheme(piabTheme);
export var App = function () {
    var i18n = useTranslation().i18n;
    useEffect(function () {
        document.documentElement.lang = i18n.language;
    }, [i18n.language]);
    return (_jsxs(StyleProvider, { theme: theme, children: [_jsx(GlobalStyle, {}), _jsx(HashRouter, { children: _jsx(AuthProvider, { children: _jsx(ConfigIdProvider, { children: _jsx(Routes, {}) }) }) })] }));
};
